import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      &copy; {new Date().getFullYear()} Bethesda Español &middot; Todos los derechos reservados
    </footer>
  );
}
